import AuthService from "../common/api-services/auth-service";
import initService from "../common/api-services/init-service";

const state = {
    navLinks: []
};

const getters = {
    allLinks(state) {
        return state.navLinks;
    },
    getLinkByLink: (state) => (link) => {
        return state.navLinks.find(item => {
            // console.log("item", item.link);
            return item.link === link
        });
    },
    getLinksByGroup: (state) => (group) => {
        return state.navLinks.filter(link => link.group === group);
    },
    getHomeLink(state) {
        return state.navLinks.find(link => link.group === "Home Group" && link.link.includes("home"));
    }
};

const actions = {
    getMenuLinks({commit}, noCache = false) {
        let groups = JSON.parse(JSON.stringify(initService.getGroups()).toUpperCase());
        let links = [];
        AuthService.getMenuLinks("All", noCache)
        .then(response => {
            if (!response.message || response.message.hasOwnProperty("error")) {
                if (!response.message) {
                    throw new Error(response);
                } else {
                    throw new Error(response.message.error);
                }
            } else {
                response.message.results && response.message.results.map(item => {
                    groups.map(role => {
                        if (item.roles.toUpperCase().includes(role) && !links.includes(item)) {
                            links.push(item);
                        }
                    })
                });
            }
        })
        .catch(error => {
            if (process.env.NODE_ENV === 'dev') {
                console.error(error);
            }
        })
        .finally(() => {
            // console.log("links", links);
            commit('setLinks', links);
        });
    }
};

const mutations = {
    setLinks(state, links) {
        state.navLinks = links;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
